import { useMemo } from "react";
import { Config } from "../types/interfaces";
import { PreferredLanguage } from "../utils/enums";

/**
 * Ensures default style values are available even when config or nested properties are missing.
 * Merges deeply and memoizes the result for consistent performance.
 */
export const useLocalConfig = (config?: Config): Required<Config> => {
	const defaultConfig: Required<Config> = {
		logo: "https://staging.scan.swanvision.ai/static/media/logo-icon-black.18f18f6cf0f9cd829f66d9b1d3a6e2f9.svg",
		loader: "../loader-black.gif",
		style: {
			base: {
				brandColor: "#5932F3",
				backgroundColor: "#FFFFFF",
				primaryColor: "#000000",
				secondaryColor: "#D9D9D9",
				baseTextColor: "#1E1E1E",
				baseFontSize: "16px",
				baseFontFamily: "'Inter', sans-serif",
			},
			logo: {
				logoWidth: "30px",
				logoHeight: "30px",
			},
			heading: {
				headingColor: "#000000",
				headingFontSize: "32px",
				headingFontWeight: "normal",
				headingFontFamily: "'SeriouslyNostalgic Fn', serif",
			},
			subheading: {
				subheadingColor: "#4b5563",
				subheadingFontSize: "14px",
				subheadingFontWeight: "normal",
				subheadingFontFamily: "'Inter', sans-serif",
			},
			button: {
				buttonBackground: "#220B12",
				buttonFontSize: "14px",
				buttonFontFamily: "'Inter', sans-serif",
				buttonDisabledBackground: "#D9D9D9",
				buttonDisabledTextColor: "#000000",
				buttonTextColor: "#FFFFFF",
				buttonBorderRadius: "9999px",
				priority: {
                    buttonBackground:"",
					buttonTextColor: "",
                    buttonDisabledTextColor: "",
                    justify:"",
                    padding:"",
                    
				},
			},
			input: {
				inputBackgroundColor: "#F9FAFC",
				inputTextColor: "#000000",
				inputPlaceholderColor: "#000000",
				inputBorderColor: "#F9FAFC",
				inputFontSize: "14px",
				inputFontWeight: "500",
				inputBorderRadius: "8px",
				inputErrorColor: "#000000",
				inputErrorFontSize: "14px",
                priority:{
                   inputBackgroundColor:"",  
                   inputTextColor:"", 
                   inputBackgroundColorSelect:"",
                   inputBackgroundColorSelectTextColor:"", 
                   inputPlaceholderColor:"",    
                }
			},
			angleDetector: {
				successAngleBackground: "#4f46e5",
				successAngleLowBackground: "#ffffff",
				successAngleTextLightColor: "#FFFFFF",
				successAngleTextDarkColor: "#000000",
			},
		},
		language: config?.language || PreferredLanguage.English,
	};

	return useMemo(
		() => ({
			logo: config?.logo ?? defaultConfig?.logo,
			loader: config?.loader || "",
			style: {
				...defaultConfig.style,
				...(config?.style || {}),
			},
			language: defaultConfig?.language,
		}),
		[config],
	);
};
